import { CATEGORIES } from '@moda/portal-stanchions';
import { canGenerateFastPath, generateFastPath, mapPathParams } from './generateFastPath';

export type Params = { [param: string]: string | undefined };
export type GenerateHref = (params?: Params, parameterize?: boolean) => string;

const isValidCategory = (category: string) => {
  return (
    !category ||
    Object.values(CATEGORIES)
      .map(cat => cat.toLowerCase())
      .includes(category.toLowerCase())
  );
};

const generateHrefFromSinglePattern = (
  pattern: string,
  params: Params = {},
  shouldParameterize = true
) => generateFastPath(pattern, mapPathParams(params, shouldParameterize));

const canGenerateHrefFromSinglePattern = (
  pattern: string,
  params: Params = {},
  shouldParameterize = true
) => canGenerateFastPath(pattern, mapPathParams(params, shouldParameterize));

export const safeGenerateHref = (
  pattern: string | string[],
  params: Params = {},
  shouldParameterize = true
) => {
  if (params?.category && !isValidCategory(params?.category)) {
    params = { ...params, category: undefined };
  }
  return generateHref(pattern)(params, shouldParameterize);
};

export const generateHref =
  (pattern: string | string[]): GenerateHref =>
  (params = {}, shouldParameterize = true) => {
    const patterns = Array.isArray(pattern) ? pattern : [pattern];
    const lastValidPattern = [...patterns]
      .reverse()
      .find(pattern => canGenerateHrefFromSinglePattern(pattern, params, shouldParameterize));

    return generateHrefFromSinglePattern(
      lastValidPattern || patterns[0] || '',
      params,
      shouldParameterize
    );
  };
